/**
 * One guide, picked by its address: /guides/budget-by-paycheck in English,
 * /es/guias/presupuesto-quincenal in Spanish — both name the same page, and
 * stripLocale turns either into the English path the guides are keyed by.
 */
import { useLocation } from 'react-router-dom';

import { stripLocale, useI18n } from '../i18n';
import { GuideLayout } from '../components/GuideLayout';
import { guidesEn } from '../guides/en';
import { guidesEs } from '../guides/es';
import { GUIDE_IDS, type GuideId } from '../guides/types';
import { isPagePath } from '../../shared/seo';
import NotFoundPage from './NotFoundPage';

export default function GuidePage() {
  const { locale } = useI18n();
  const { pathname } = useLocation();
  const path = stripLocale(pathname);
  const id = path.slice('/guides/'.length) as GuideId;

  if (!GUIDE_IDS.includes(id) || !isPagePath(path)) return <NotFoundPage />;

  const guides = locale === 'es' ? guidesEs : guidesEn;
  const related = GUIDE_IDS.filter((other) => other !== id).map((other) => guides[other]);
  return <GuideLayout guide={guides[id]} path={path} related={related} />;
}
